import { render, staticRenderFns } from "./lstGoldenSampleFeature.vue?vue&type=template&id=16ea9083&"
import script from "./lstGoldenSampleFeature.vue?vue&type=script&lang=js&"
export * from "./lstGoldenSampleFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports